import assign from 'lodash-es/assign';
import debounce from 'lodash-es/debounce';
import isArray from 'lodash-es/isArray';
import isFunction from 'lodash-es/isFunction';
import isString from 'lodash-es/isString';

import manager from '../../store/Attributes.manager';
import { AttributesStore } from '../../store/AttributesStore';

import { playSound, setSound } from '../sound.service';
import { keysToLowerCase } from '../utils';

import queryParams from './params';

const error = debounce(function () {
  console.error('Sorry:) Your current plan doesn\'t allow you to use WidgetAPI');
}, 100);

export function createUfNS(global, api, localApi) {
  const {
    setUsername, setEmail, addTags, removeTags,
    sendApiMessage, sendApiRequest, setColor, setOffsetX, setOffsetY, setPosition,
    setCustomData, sendMessage
  } = api;

  const new$ufNS = prepare$ufNS();

  const params = assign(queryParams(), new$ufNS.params);

  if (params.customData) {
    new$ufNS._.unshift(() => setCustomData(params.customData));
  }

  const tags = isString(params.tags) ? [params.tags] : params.tags;
  if (isArray(tags)) {
    new$ufNS._.unshift(() => addTags(...tags));
  }

  if (isString(params.color)) {
    new$ufNS._.unshift(() => setColor(params.color));
  }

  if (params.offsetX) {
    new$ufNS._.unshift(() => setOffsetX(params.offsetX));
  }

  if (params.offsetY) {
    new$ufNS._.unshift(() => setOffsetY(params.offsetY));
  }

  if (params.position) {
    new$ufNS._.unshift(() => setPosition(params.position));
  }

  if (typeof params.hideAll === 'boolean') {
    new$ufNS._.unshift(() => {
      return params.hideAll ? manager.hideAll() : null;
    });
  }

  new$ufNS.widget = {
    getVersion: localApi.getVersion,
    remount: checkApi.bind(null, localApi.remount),
    setFlashcard: checkApi.bind(null, manager.setFlashcard),
    sendApiMessage: checkApi.bind(null, sendApiMessage),
    show: checkApi.bind(null, localApi.show),
    hide: checkApi.bind(null, localApi.hide),
    liftAll: checkApi.bind(null, manager.liftAll),
    hideAll: checkApi.bind(null, manager.hideAll),
    toggle: checkApi.bind(null, localApi.toggle),
    setUsername: checkApi.bind(null, setUsername),
    setEmail: checkApi.bind(null, setEmail),
    setMediaMobileWidth: checkApi.bind(null, manager.setMediaMobileWidth),
    addTags: checkApi.bind(null, addTags),
    removeTags: checkApi.bind(null, removeTags),
    setColor: checkApi.bind(null, setColor),
    setOffsetX: checkApi.bind(null, setOffsetX),
    setOffsetY: checkApi.bind(null, setOffsetY),
    setPosition: checkApi.bind(null, setPosition),
    setCustomData: checkApi.bind(null, setCustomData),
    setTitle: checkApi.bind(null, setTranslation.bind(null, 'LOADER_TITLE')),
    setTranslation: checkApi.bind(null, setTranslation),
    sendMessage: checkApi.bind(null, sendMessage),
    setStyleTemplate: checkApi.bind(null, sendApiMessage.bind(null, 'styleTemplate')),
    setCloseSessionButton: checkApi.bind(null, sendApiMessage.bind(null, 'closeSessionBtn')),
    allowCloseSession: checkApi.bind(null, sendApiMessage.bind(null, 'allowCloseSession')),
    setOpenOnTrigger: checkApi.bind(null, sendApiMessage.bind(null, 'openOnTrigger')),
    setSound: checkApi.bind(null, setSound),
    playSound: checkApi.bind(null, playSound),
    shouldPlaySound: checkApi.bind(null, sendApiMessage.bind(null, 'notificationSound')),
    setOnChatEnd: checkApi.bind(null, manager.setCallback.bind(null, 'onChatEnd')),
    setOnChatStart: checkApi.bind(null, manager.setCallback.bind(null, 'onChatStart')),
    getState: checkApi.bind(null, sendApiRequest.bind(null, 'getState')),
    setItemsOrder: checkApi.bind(null, setItemsOrder)
  };

  return new$ufNS;

  function prepare$ufNS() {
    const defaults = { _: [], s: '', params: {}, widget: {} };
    return assign(function (cb) {
      if (isFunction(cb)) cb();
    }, defaults, global.$uf || {});
  }

  // function checkApi(method: (...args) => void, ...args) {
  function checkApi(method, ...args) {
    if (!AttributesStore.get('canUseAPI')) {
      return error();
    }
    return method(...args);
  }

  function setItemsOrder(value) {
    return manager.setItemsOrder(keysToLowerCase(value));
  }

  function setTranslation(key, value) {
    value = typeof value === 'object' ? value : { en: value, pl: value };

    const overwrite = { en: {}, pl: {} };
    overwrite.en[key] = value.en;
    overwrite.pl[key] = value.pl;

    if (/LOADER/.test(key)) {
      return manager.setFlattenedTranslation(overwrite);
    }

    return sendApiMessage('setTranslation', overwrite);
  }
}
